import * as R from 'ramda'

import { notEmpty } from 'utils/notEmpty'

import type { FilterValueType } from './types'

const PROPERTY_UNITS: Record<keyof FilterValueType, string> = {
  blur: 'px',
  brightness: '%',
  contrast: '%',
  ['hue-rotate']: 'deg',
  invert: '%',
  saturate: '%',
  sepia: '%',
}

export const DEFAULT_FILTER: Required<FilterValueType> = {
  blur: { value: 0, on: false },
  brightness: { value: 100, on: false },
  contrast: { value: 100, on: false },
  ['hue-rotate']: { value: 0, on: false },
  invert: { value: 0, on: false },
  saturate: { value: 100, on: false },
  sepia: { value: 0, on: false },
}

export const safeParseFilter = (value?: string | null): FilterValueType | null => {
  try {
    return value ? JSON.parse(value) : null
  } catch {
    return null
  }
}

export const applyFilter = (filter?: FilterValueType | string | null): string | undefined => {
  if (!filter) {
    return undefined
  }
  const value = (typeof filter === 'string' ? safeParseFilter(filter) : filter) || DEFAULT_FILTER

  if (!value) {
    return undefined
  }

  const array = R.toPairs(R.pick(R.keys(PROPERTY_UNITS), value))
    .filter((item) => item?.[1]?.on)
    .filter(notEmpty)
  const res = array.map(([key, value]) => `${key}(${value?.value}${PROPERTY_UNITS[key]})`).join(' ')
  return res || undefined
}

export const saveFilter = (value?: FilterValueType | null) => (value ? JSON.stringify(value) : null)
